module.exports = __webpack_public_path__ + "src/img/verify-success.1a07b7b8.svg";